// extracted by mini-css-extract-plugin
export var gridWrapper = "style-module--gridWrapper--cXKhy";
export var imgWrapper = "style-module--imgWrapper--SEWa9";
export var mainWrapper = "style-module--mainWrapper--9N0Oj";